var _defs, _ellipse, _circle, _g, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sat",
    cx: "35%",
    cy: "30%",
    r: "82%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f0d29d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c49a5e"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 148,
    ry: 30,
    fill: "none",
    stroke: "#d8b98a",
    strokeWidth: 9,
    transform: "rotate(-18 100 100)",
    opacity: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 88,
    fill: "url(#sat)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#a98045",
    strokeOpacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 74 h164",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 96 h172",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 118 h160",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 140 h168",
    strokeWidth: 5
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 150,
    ry: 32,
    fill: "none",
    stroke: "#d8b98a",
    strokeWidth: 9,
    transform: "rotate(-18 100 100)",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturn);
export default __webpack_public_path__ + "static/media/saturn.26a8dbda1caaf2c34c7b232790d2e419.svg";
export { ForwardRef as ReactComponent };